import axios from 'axios';
import parseDotEnv from '../../utils/parserDotEnv';
import { setDetails } from '../../redux/env/env';

export async function getEnvConfig(): Promise<any> {
  const envConfig = await (await fetch('/environment.env')).text();
  const response = parseDotEnv(envConfig);
  setDetails(response);
  return response;
}

export async function getStatusPageSummary(): Promise<any> {
  const env = await getEnvConfig();
  const statusPageId = env['STATUSPAGE_PAGE_ID'];
  return await axios.get(`https://${statusPageId}.statuspage.io/api/v2/summary.json`);
}

export async function getStatusPageSummaryForProd(): Promise<any> {
  const env = await getEnvConfig();
  const statusPageId = env['STATUSPAGE_PAGE_ID_PROD'];
  return await axios.get(`https://${statusPageId}.statuspage.io/api/v2/summary.json`);
}
